import React from 'react'
import InputMask from 'react-input-mask'
import { TextValidator } from 'react-material-ui-form-validator'

import { useLabel } from '../../../../hooks/useLabel'
import { applyPostalMask } from '../../../../util/addressFormats'
import fetchViaCep from '../../../../util/viaCep'

const onlyDigits = value => (value || '').replace(/\D/g, '')

// Código postal com a máscara do país. Com busca automática (ViaCEP, só no BR), ao sair
// do campo repassa o endereço encontrado
const PostalCodeField = ({ value, onChange, onLookup, format }) => {
  const label = useLabel()

  const handleLookup = async () => {
    if (!format.postalLookup) return

    const cep = onlyDigits(value)

    if (cep.length !== 8) return

    try {
      const resp = await fetchViaCep(cep)

      if (!resp) return

      onLookup({
        city: resp?.localidade,
        uf: resp?.uf,
        street: resp?.logradouro,
        neighborhood: resp?.bairro,
      })
    } catch (e) {
      // falha na busca do CEP: mantém o que foi digitado
    }
  }

  const handleChange = e => {
    const digits = onlyDigits(e.target.value)

    onChange(applyPostalMask(format.postalMask(digits), digits))
  }

  return (
    <InputMask
      mask={format.postalMask(onlyDigits(value))}
      formatChars={{ 9: '[0-9]', '?': '[0-9]' }}
      maskChar=""
      value={value}
      onChange={handleChange}
      onBlur={handleLookup}
    >
      {inputProps => (
        <TextValidator
          {...inputProps}
          errorMessages={['Campo Obrigatório']}
          label={label('cep', 'CEP')}
          fullWidth
          value={value}
        />
      )}
    </InputMask>
  )
}

export default PostalCodeField
